export type NbComponentSize = 'tiny' | 'small' | 'medium' | 'large' | 'giant';
